module.exports = __webpack_public_path__ + "static/img/env19.a010ca1.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/env19.png
// module id = 112
// module chunks = 4